export default __webpack_public_path__ + "static/media/udea-main-logo-en-white.dcf723db.svg";